import { Map } from 'maplibre-gl';
import { IRegion } from '@/types/explorer';

export const SOURCE_ID = 'hm-regionLabel-source';

export const getRegionSource = (regions: IRegion[]) => {
  const source: any = regions.reduce(
    (acc: any, curr: IRegion) => {
      acc.features.push({
        type: 'Feature',
        id: curr.id,
        properties: {
          name: curr.name,
        },
        geometry: {
          type: 'Point',
          coordinates: [curr.focalPoint.lon, curr.focalPoint.lat],
        },
      });
      return acc;
    },
    {
      type: 'FeatureCollection',
      features: [],
    },
  );
  return source;
};

export async function addSource(map: Map, regions: IRegion[]) {
  if (map && !map.getSource(SOURCE_ID)) {
    map.addSource(SOURCE_ID, {
      type: 'geojson',
      data: getRegionSource(regions),
    });
  }
}
